import { useQuery } from '@apollo/client';
import type { FindSegmentQueryResult } from '@/gql/graphql';
import type { Segment } from '@/routes/segments/types';
import { GET_ALL_SEGMENTS_METADATA } from '@/queries/segments';
interface ChannelCounts {
  sms: number;
  email: number;
  push: number;
}
const approximateChannelCounts = (size: number | null | undefined): ChannelCounts => ({
  sms: size ?? 0,
  email: 0,
  push: 0
});

export function useSegments(includeDeleted = false) {
  const { data, loading, error, refetch } = useQuery<{
    getAllSegmentMetadataForMerchant: FindSegmentQueryResult[];
  }>(GET_ALL_SEGMENTS_METADATA, {
    variables: { includeDeleted }
  });

  const segments: Segment[] =
    data?.getAllSegmentMetadataForMerchant
      .filter((segment) => segment.active)
      .map(
        (segment): Segment => ({
          id: segment.id,
          name: segment.name,
          description: segment.description,
          channelCounts: approximateChannelCounts(segment.lastCalculatedSize),
          createdAt: segment.createdAt,
          lastSync: segment.lastCalculatedAt ?? ''
        })
      ) ?? [];

  return {
    segments,
    loading,
    error,
    refetch
  };
}
